import type {
    ContestBlockType,
    ContestChannel,
    ContestEntryPath,
    ContestGrantSource,
    ContestUncountedReason,
} from '../../../stores/contest';

export const ENTRY_PATH_LABELS: Record<ContestEntryPath, string> = {
    purchase: 'Purchase',
    no_purchase: 'No purchase',
    referral: 'Referral',
    photo: 'Photo',
};

export const GRANT_SOURCE_LABELS: Record<ContestGrantSource, string> = {
    block: 'Block',
    in_store: 'In-store purchase',
};

export const BLOCK_TYPE_LABELS: Record<ContestBlockType, string> = {
    text_image: 'Text and image',
    code_entry: 'Code',
    no_purchase_entry: 'No purchase',
    referral: 'Referral',
    photo_entry: 'Photo',
    contact_form: 'Contact form',
    faq: 'FAQ',
};

export const UNCOUNTED_REASON_LABELS: Record<ContestUncountedReason, string> = {
    friend_cap: 'Friend cap reached',
    contest_total_cap: 'Contest cap reached',
    skill_challenge: 'Waiting for the skill-testing question',
};

export const CHANNEL_LABELS: Record<ContestChannel, string> = {
    browser: 'Browser',
    ios_app: 'iOS app',
    android_app: 'Android app',
};
